/*============================================================
   REACT DEPENDENCIES
============================================================*/
import { useState } from "react";

/*============================================================
   REDUX DEPENDENCIES
============================================================*/
import { useDispatch, useSelector } from "react-redux";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";

import GridSectionHeader from "../../widgets/GridSectionHeader";
import GridTextfield from "../../widgets/GridTextfield";

import { validateCurrencyField2, validateCurrencyField3 } from "../../../utils/fieldValidator.js";
import PageNavigator, { onNext } from "../../../components/PageNavigator.js";

//DATA SLICE - REDUCER
import { updateAffordability } from "../../../states/slcAffordability.js";

var annualCashError = "";
var annualCPFOAError = "";
var annualCPFSAError = "";
var annualCPFMAError = "";
var annualSRSError = "";

var singleCashError = "";
var singleCPFOAError = "";
var singleCPFSAError = "";
var singleCPFMAError = "";
var singleSRSError = "";

//TRUE - WHEN COMPONENT IS VALID
var validAffordability = true;

export default function Affordability() {
  const affordability = useSelector((state) => state.affordability);

  /**
   *
   * TRUE - WHEN COMPONENT IS VALID AND "NEXT PAGE" BUTTON IS ENABLED
   *        ALL SUB COMPONENTS SHOULD BE VALID FOR THIS TO BE TRUE
   */
  const [enableNext, setEnableNext] = useState(false);

  const [annualCash, setAnnualCash] = useState(affordability.annualCash);
  const [annualCPFOA, setAnnualCPFOA] = useState(affordability.annualCPFOA);
  const [annualCPFSA, setAnnualCPFSA] = useState(affordability.annualCPFSA);
  const [annualCPFMA, setAnnualCPFMA] = useState(affordability.annualCPFMA);
  const [annualSRS, setAnnualSRS] = useState(affordability.annualSRS);

  const [singleCash, setSingleCash] = useState(affordability.singleCash);
  const [singleCPFOA, setSingleCPFOA] = useState(affordability.singleCPFOA);
  const [singleCPFSA, setSingleCPFSA] = useState(affordability.singleCPFSA);
  const [singleCPFMA, setSingleCPFMA] = useState(affordability.singleCPFMA);
  const [singleSRS, setSingleSRS] = useState(affordability.singleSRS);

  const dispatch = useDispatch();

  //COMPONENT ID
  let id = "";

  function updateRedux(fieldName, fieldValue, reducer) {
    const action = {
      type: fieldName,
      payload: fieldValue,
    };
    dispatch(reducer(action));
  }

  function handleChange(e, object) {
    let input_data = {
      event: e,
      fieldName: "",
      fieldVariable: "",
      isMandatory: false,
    };

    //TEXTFIELDS
    id = e.target.id;

    validateAnnual(e, id, input_data);
    validateSingle(e, id, input_data);
    calculateValidity();
  }

  //AFFORDABILITY - CASH
  function validateAnnual(e, id, input_data) {
    console.log("id = " + id);

    if (id === "annualCash") {
      input_data.fieldName = "Annual Amount";
      input_data.fieldVariable = annualCash;
      const result = validateCurrencyField3(input_data);
      if (result.errorMessage === "") {
        setAnnualCash(result.value);
        updateRedux("annualCash", result.value, updateAffordability);
      } else annualCashError = result.errorMessage;
    }

    if (id === "annualCPFOA") {
      input_data.fieldName = "Annual CPF Original Account";
      input_data.fieldVariable = annualCPFOA;
      const result = validateCurrencyField3(input_data);
      if (result.errorMessage === "") {
        setAnnualCPFOA(result.value);
        updateRedux("annualCPFOA", result.value, updateAffordability);
      } else annualCPFOAError = result.errorMessage;
    }

    if (id === "annualCPFSA") {
      input_data.fieldName = "Annual CPF Special Account";
      input_data.fieldVariable = annualCPFSA;
      const result = validateCurrencyField3(input_data);
      if (result.errorMessage === "") {
        setAnnualCPFSA(result.value);
        updateRedux("annualCPFSA", result.value, updateAffordability);
      } else annualCPFSAError = result.errorMessage;
    }

    if (id === "annualCPFMA") {
      input_data.fieldName = "Annual CPF Medisave Account";
      input_data.fieldVariable = annualCPFMA;
      const result = validateCurrencyField3(input_data);
      if (result.errorMessage === "") {
        setAnnualCPFMA(result.value);
        updateRedux("annualCPFMA", result.value, updateAffordability);
      } else annualCPFMAError = result.errorMessage;
    }

    if (id === "annualSRS") {
      input_data.fieldName = "Annual SRS Account";
      input_data.fieldVariable = annualSRS;
      const result = validateCurrencyField3(input_data);
      if (result.errorMessage === "") {
        setAnnualSRS(result.value);
        updateRedux("annualSRS", result.value, updateAffordability);
      } else annualSRSError = result.errorMessage;
    }
  }

  //AFFORDABILITY - ORDINARY ACCOUNT
  function validateSingle(e, id, input_data) {
    if (id === "singleCash") {
      input_data.fieldName = "Single Amount";
      input_data.fieldVariable = singleCash;
      const result = validateCurrencyField3(input_data);
      if (result.errorMessage === "") {
        setSingleCash(result.value);
        updateRedux("singleCash", result.value, updateAffordability);
      } else singleCashError = result.errorMessage;
    }

    if (id === "singleCPFOA") {
      input_data.fieldName = "Single CPF Original Account";
      input_data.fieldVariable = singleCPFOA;
      const result = validateCurrencyField3(input_data);
      if (result.errorMessage === "") {
        setSingleCPFOA(result.value);
        updateRedux("singleCPFOA", result.value, updateAffordability);
      } else singleCPFOAError = result.errorMessage;
    }

    if (id === "singleCPFSA") {
      input_data.fieldName = "Single CPF Special Account";
      input_data.fieldVariable = singleCPFSA;
      const result = validateCurrencyField3(input_data);
      if (result.errorMessage === "") {
        setSingleCPFSA(result.value);
        updateRedux("singleCPFSA", result.value, updateAffordability);
      } else singleCPFSAError = result.errorMessage;
    }

    if (id === "singleCPFMA") {
      input_data.fieldName = "Single CPF Medisave Account";
      input_data.fieldVariable = singleCPFMA;
      const result = validateCurrencyField3(input_data);
      if (result.errorMessage === "") {
        setSingleCPFMA(result.value);
        updateRedux("singleCPFMA", result.value, updateAffordability);
      } else singleCPFMAError = result.errorMessage;
    }

    if (id === "singleSRS") {
      input_data.fieldName = "Single SRS Account";
      input_data.fieldVariable = singleSRS;
      const result = validateCurrencyField3(input_data);
      if (result.errorMessage === "") {
        setSingleSRS(result.value);
        updateRedux("singleSRS", result.value, updateAffordability);
      } else singleSRSError = result.errorMessage;
    }
  }

  function validateForm(e) {
    e.preventDefault();
    onNext();
  }

  function calculateValidity() {
    validAffordability = false;

    //Nothing to validate all non mandatory field let them through the momenth interation with form is detected.

    validAffordability = true;
    setEnableNext(true);
  }

  return (
    <>
      <Box component="form" onSubmit={validateForm} noValidate>
        <Grid container spacing={2}>
          {/* SIMPLIFIED INCOME & EXPENSES */}
          <GridSectionHeader
            sectionName="Affordability"
            sx={{
              p: 1,
              pl: 1.8,
              mt: 0,
              mb: 1,
              fontSize: 18,
              fontWeight: "bold",
              color: "#FFFFFF", //WHITE
              // color: "#000000", //BLACK
              // backgroundColor: "#d9d9d9",
              backgroundColor: "#10B981",
            }}
          />

          {/* DECLARATION: DO NOT WISH TO DISCLOSE CASH FLOW INFORMATION */}
          <Typography variant="body1" gutterBottom>
            Please indicate the amount that is within your affordability to set aside your objectives andf whether the
            amount is substantial portion of your assets and income.
          </Typography>

          <Accordion>
            <AccordionSummary expandIcon={<ArrowDropDownIcon />} aria-controls="panel1-content" id="panel1-header">
              <Typography variant="body2" align="justify" sx={{ textDecoration: "underline", fontWeight: 1000 }}>
                Affordability Guide
              </Typography>
            </AccordionSummary>

            <AccordionDetails>
              <Typography variant="body2" align="justify">
                <li>As a guide the amount you're willing to invest should be no more than 50%</li>
              </Typography>

              <Typography variant="body2" align="justify">
                <li>Annual Cashflow and/or Total Cash/Near Cash, for Cash.</li>
              </Typography>
              <Typography variant="body2" align="justify">
                <li>CPF Balance (OA) in Section Assets & Liabilities, for CPF Ordinary Account</li>
              </Typography>
              <Typography variant="body2" align="justify">
                <li>CPF Balance (SA) in Section Assets & Liabilities, for CPF Special Account</li>
              </Typography>
              <Typography variant="body2" align="justify">
                <li>CPF Balance (MA) in Section Assets & Liabilities, for CPF Medisave Account</li>
              </Typography>
              <Typography variant="body2" align="justify">
                <li>For SRS, you should not invest more than 100% of your total SRS in Section Assets & Liabilities</li>
              </Typography>
              <Typography variant="body2" align="justify">
                <li>
                  It is recommended that you should also set aside 3 to 6 months of your monthly outflow if income is
                  regular or 12 months if income is irregular, for emergency purposes.
                </li>
              </Typography>
            </AccordionDetails>
          </Accordion>

          {/* Affordability - Cash*/}
          <Grid size={12}>
            <Typography variant="h6" gutterBottom sx={{ backgroundColor: "lightgray" }}>
              Cash
            </Typography>
          </Grid>

          <GridTextfield
            id="annualCash"
            columnSize="6"
            required={false}
            label="Annual Amount"
            currState={annualCash}
            isCurrency={true}
            onChange={handleChange}
          />

          <GridTextfield
            id="singleCash"
            columnSize="6"
            required={false}
            label="Single Amount"
            currState={singleCash}
            isCurrency={true}
            onChange={handleChange}
          />

          {/* Affordability - CPF Ordinary Account*/}
          <Grid size={12}>
            <Typography variant="h6" gutterBottom sx={{ backgroundColor: "lightgray" }}>
              CPF Ordinary Account
            </Typography>
          </Grid>

          <GridTextfield
            id="annualCPFOA"
            columnSize="6"
            required={false}
            label="Annual Amount"
            currState={annualCPFOA}
            isCurrency={true}
            onChange={handleChange}
          />

          <GridTextfield
            id="singleCPFOA"
            columnSize="6"
            required={false}
            label="Single Amount"
            currState={singleCPFOA}
            isCurrency={true}
            onChange={handleChange}
          />

          {/* Affordability - CPF Special Account*/}
          <Grid size={12}>
            <Typography variant="h6" gutterBottom sx={{ backgroundColor: "lightgray" }}>
              CPF Special Account
            </Typography>
          </Grid>

          <GridTextfield
            id="annualCPFSA"
            columnSize="6"
            required={false}
            label="Annual Amount"
            currState={annualCPFSA}
            isCurrency={true}
            onChange={handleChange}
          />

          <GridTextfield
            id="singleCPFSA"
            columnSize="6"
            required={false}
            label="Single Amount"
            currState={singleCPFSA}
            isCurrency={true}
            onChange={handleChange}
          />

          {/* Affordability - CPF Medisave Account*/}
          <Grid size={12}>
            <Typography variant="h6" gutterBottom sx={{ backgroundColor: "lightgray" }}>
              CPF Medisave Account
            </Typography>
          </Grid>

          <GridTextfield
            id="annualCPFMA"
            columnSize="6"
            required={false}
            label="Annual Amount"
            currState={annualCPFMA}
            isCurrency={true}
            onChange={handleChange}
          />

          <GridTextfield
            id="singleCPFMA"
            columnSize="6"
            required={false}
            label="Single Amount"
            currState={singleCPFMA}
            isCurrency={true}
            onChange={handleChange}
          />

          {/* Affordability - Supplementary Retirement Scheme*/}
          <Grid size={12}>
            <Typography variant="h6" gutterBottom sx={{ backgroundColor: "lightgray" }}>
              Supplementary Retirement Scheme
            </Typography>
          </Grid>

          <GridTextfield
            id="annualSRS"
            columnSize="6"
            required={false}
            label="Annual Amount"
            currState={annualSRS}
            isCurrency={true}
            onChange={handleChange}
          />

          <GridTextfield
            id="singleSRS"
            columnSize="6"
            required={false}
            label="Single Amount"
            currState={singleSRS}
            isCurrency={true}
            onChange={handleChange}
          />

          <PageNavigator validator={validateForm} isValid={enableNext} />
        </Grid>
      </Box>
    </>
  );
}
